import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeBranch, faFireBurner, faLocation, faBarcode, faUpload } from '@fortawesome/free-solid-svg-icons';
import { CanAccess, ConditionalRender } from '../../components/permissions';
import { useAuth } from '../../hooks/auth-provider';

const Dashboard = () => {
    const { hasPermission, hasAnyPermission, hasRole } = useAuth();

    return (
        <div className="surface-ground px-4 py-5">
            <div className="surface-ground">
                <div className="grid">
                    <CanAccess permissions={['mm.view', 'mm.create']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/mmadmin">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-indigo-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faLocation} className="text-indigo-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Kreiranje naloga</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Admin ekran za inženjere</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>
                    <CanAccess permissions={['mm.update']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/mmupload">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-indigo-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faUpload} className="text-indigo-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Upload dokumenata</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Dopuna podataka za merno mesto</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    <CanAccess permissions={['mm.view', 'mm.create']} rolesExclude={['inzenjer']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/mm-simple">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-orange-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faLocation} className="text-orange-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Terenski rad</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Osnovni ekran operatera</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    <CanAccess module="pkgp" action="view">
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/pkgp">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-green-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faFireBurner} className="text-green-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Nalozi za pregled KGP</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Administracija naloga</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    <CanAccess module="pugi" action="view">
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/pugi">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-green-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faCodeBranch} className="text-green-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Nalozi za pregled UGI</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Administracija naloga</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    {/* Zamena meraca - za inženjere */}
                    <CanAccess module="zm" action="view">
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/zm">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-green-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faLocation} className="text-green-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Zamena meraca</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Upravljanje ZM</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>
                    <CanAccess permissions={['mm.view', 'mm.barcode_scan', 'mm.create_nalog']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/mm/newnalog">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-orange-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <FontAwesomeIcon icon={faBarcode} className="text-orange-600 text-3xl" />
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Pronađi nalog</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">A potopm kreiraj novi ili otvori postojeći nalog</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    {/* Fakture - samo za super_admin */}
                    <CanAccess module="faktura" action="view">
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/faktura">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-purple-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <i className="pi pi-file text-purple-600 text-3xl"></i>
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Fakture</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Upravljanje fakturama</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    {/* Korisnici - za admin i super_admin */}
                    <CanAccess module="users" action="view">
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/users">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-cyan-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <i className="pi pi-users text-cyan-600 text-3xl"></i>
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Korisnici</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Upravljanje korisnicima</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    {/* Permissions - za super_admin */}
                    <CanAccess permissions={['permissions.view', 'roles.view']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/permissions">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-pink-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <i className="pi pi-lock text-pink-600 text-3xl"></i>
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Dozvole i Role</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Upravljanje dozvolama</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>

                    {/* Moj profil - dostupan svim korisnicima */}
                    <CanAccess rolesExclude={['inzenjer']}>
                        <div className="col-12 lg:col-4 p-3">
                            <Link to="/my-profile">
                                <div className="p-3 border-round shadow-2 flex align-items-center surface-card">
                                    <div
                                        style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '10px'
                                        }}
                                        className="bg-blue-100 inline-flex align-items-center justify-content-center mr-3"
                                    >
                                        <i className="pi pi-user text-blue-600 text-3xl"></i>
                                    </div>
                                    <div>
                                        <span className="text-900 text-xl font-medium mb-2">Moj profil</span>
                                        <p className="mt-1 mb-0 text-600 font-medium text-sm">Izmena potpisa</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </CanAccess>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
